




















import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { search_invoices } from '@/api/invoice';
import { list_product_summaries } from '@/api/product';
import { ProductTypeEnum } from '@/api/types';

@Component({
  name: 'InvoiceListDialogExtraInfo',
})
export default class extends Vue {
  @Prop({ required: true }) products!: Map<
    string,
    list_product_summaries.Product
  >;
  @Prop({ required: true })
  extraInfo!: search_invoices.InvoiceSummary.ExtraInfo;
  private entries: search_invoices.InvoiceSummary.ExtraInfoEntry[] = [];

  mounted() {
    this.entries = Array.from(Object.keys(this.extraInfo)).map(
      k =>
        ({
          key: this.getProductNameOrKeyText(k),
          value: this.extraInfo[k],
        } as search_invoices.InvoiceSummary.ExtraInfoEntry)
    );
  }

  private getProductNameOrKeyText(key: string) {
    return this.products.has(key)
      ? `[${this.$t('ProductTypeEnum.' + this.products.get(key)!.type)}]${
          this.$i18n.locale !== 'ja' && this.products.get(key)!.nameEn
            ? this.products.get(key)!.nameEn
            : this.products.get(key)!.name
        }${
          this.products.get(key)!.fiscalYear === 0
            ? ''
            : ' [' + this.products.get(key)!.fiscalYear + ']'
        }`
      : key;
  }
}
